// ProjectRamsPanel — RAMS requests scoped to one project (used in the Project
// detail "RAMS" tab). Thin wrapper around the same dashboard, pre-filtered.
import RamsDashboardPage from "@/pages/rams/RamsDashboardPage";

export default function ProjectRamsPanel({ projectId, clientId }) {
    return <RamsDashboardPage presetClientId={clientId} presetProjectId={projectId} compact />;
}
